module.exports = __webpack_public_path__ + "img/whiteThirdBg.1adef68f.png";